import { Component, ComponentFactoryResolver, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import { FormControlName, NgModel } from '@angular/forms';
import { CounterSharedService } from './counterSevice';
import { CounterValueComponent } from './counterValue.component';

@Component({
  selector: '[axis-counter]',
  template: '',
  host: {
    '[attr.maxlength]': 'max'
  }
})
export class CounterComponent implements OnInit {
  @Input() max: number;
  private counterCompRef: any;
  @Output() counterUpdated: EventEmitter<number> = new EventEmitter();
  public counter: number;
  private prevValue: number;
  constructor(
    private viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    private model: NgModel,
    private formControlName: FormControlName,
    private eleRef: ElementRef,
    private counterSharedService: CounterSharedService
  ) { }

  ngOnInit() {
    this.counter = 0;
    this.counterUpdated.emit(this.counter);
    const key = this.counterSharedService.generateUniqueKey();
    this.counterSharedService.setInstance(this, key);
    this.counterSharedService.loadCounterValue(this.counter, key);
    const resetSelectionCompFactory = this.resolver.resolveComponentFactory(
      CounterValueComponent
    );
    this.counterCompRef = this.viewContainerRef.createComponent(
      resetSelectionCompFactory
    );
    this.counterCompRef.instance.uniqueKey = key;
    if (
      this.model &&
      this.model.valueChanges &&
      this.model.hasOwnProperty('viewModel')
    ) {
      this.model.valueChanges.subscribe(value => {
        this.updateOnChange(value);
      });
    }
    if (this.formControlName && this.formControlName.valueChanges) {
      this.formControlName.valueChanges.subscribe(value => {
        this.updateOnChange(value);
      });
    }
  }
  @HostListener('keydown', ['$event.target'])
  onKeyPress(): void {
    this.counterSharedService.changePosition(this.eleRef);
  }
  @HostListener('input', ['$event', '$event.target.value'])
  onInputChange(event, value) {
    if (
      !this.formControlName.valueChanges &&
      !this.model.hasOwnProperty('viewModel')
    ) {
      this.updateOnChange(value);
    }
  }
  @HostListener('focus', ['$event', '$event.target.value'])
  onFocus(event, value) {
    this.updateOnChange(value);
    this.counterSharedService.changePosition(this.eleRef);
  }
  updateOnChange(value) {
    if (value && typeof value === 'string') {
      this.onChange(value);
    } else {
      value = value && value.toString();
      if (value && (value.length > this.max)) {
        this.eleRef.nativeElement.value = this.prevValue;
        this.model.update.emit(this.prevValue);
        return;
      } else {
        this.prevValue = value;
        this.onChange(value);
      }
    }
  }
  onChange(data) {
    const textLength = data ? data.length : 0;
    this.counter = textLength;
    this.counterUpdated.emit(this.counter);
    this.counterSharedService.loadCounterValue(
      this.counter,
      this.counterCompRef.instance.uniqueKey
    );
  }
}
